export const EMAIL_REGEX = /^(?:(?:[^<>()\[\]\\.,;:\s@"]+(?:\.[^<>()\[\]\\.,;:\s@"]+)*)|(?:".+"))@((?:\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(?:(?:[a-zA-Z\-0-9]+\.)+[a-zA-Z0-9]{2,}))$/;

export const GOOGLE_DOMAINS = ['gmail', 'googlemail'];
export const YAHOO_DOMAINS = ['yahoo', 'ymail'];

export const MIN_TTL = 600;

export const MIN_DELTA_VERIFY_CALL_MIN = 15;

export const AUTH_DOMAIN_DELIVERABILITY = 'Deliverability';
export const AUTH_DOMAIN_BRANDED_LINKS = 'Branded Links';

export const AUTHENTICATE_EMAIL_HEADERS = Object.freeze([
  {
    text: 'DNS TYPE',
    value: 'dns_type',
    align: 'left',
    sortable: false,
  },
  {
    text: 'NAME',
    value: 'name',
    align: 'left',
    sortable: false,
  },
  {
    text: 'DATA',
    value: 'data',
    align: 'left',
    sortable: false,
  },
  {
    text: 'TTL',
    value: 'ttl',
    align: 'left',
    sortable: false,
  },
  {
    text: 'VERIFIED?',
    value: 'verified',
    align: 'left',
    sortable: false,
  },
]);

export const CONNECT_EMAIL_HEADERS = Object.freeze([
  {
    text: 'Email Account',
    value: 'email',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Send Limit',
    value: 'limits',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Sent',
    value: 'used',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Active',
    value: 'status',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Send Email',
    value: 'send_email',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Sync Email',
    value: 'sync_email',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Import Contacts',
    value: 'sync_contacts',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Sync Calendar',
    value: 'sync_calendar',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Disconnect',
    value: 'disconnect',
    align: 'left',
    sortable: false,
  },
]);

export const MOCK_DATA = {
  email: 'user@mymail.mydomain.com',
  authDomainEmail: [
    {
      dns_type: 'CNAME',
      name: 'em123',
      data: 'u1234567.wl128.sendgrid.net',
      ttl: '600 secs',
      verified: true,
    },
    {
      dns_type: 'CNAME',
      name: 's1._domainkey',
      data: 's1.domainkey.u1234567.wl128.sendgrid.net',
      ttl: '600 secs',
      verified: true,
    },
    {
      dns_type: 'CNAME',
      name: 's2._domainkey',
      data: 's2.domainkey.u1234567.wl128.sendgrid.net',
      ttl: '600 secs',
      verified: true,
    },
    {
      dns_type: 'TXT',
      name: '_dmarc',
      data: 'v=DMARC1; p=none;',
      ttl: '600 secs',
      verified: true,
    },
    {
      dns_type: 'CNAME',
      name: '1234567',
      data: 'sendgrid.net',
      ttl: '600 secs',
      verified: true,
    },
    {
      dns_type: 'CNAME',
      name: 'link',
      data: 'sendgrid.net',
      ttl: '600 secs',
      verified: false,
    },
  ],
  emailAccounts: [
    {
      provider_id: 1,
      email: 'email@gmail.com',
      limits: 300,
      available_usage: 139,
    },
    {
      provider_id: 2,
      email: 'email@outlook.com',
      limits: 7500,
      available_usage: 6829,
    },
    {
      provider_id: 3,
      email: 'email@lwolf.com',
      limits: 4444,
      available_usage: 444,
    },
  ],
  emails: [
    {
      email: 'email@gmail.com',
      type: 'nylas',
      enoughLimits: true,
    },
    {
      email: 'email@yahoo.com',
      type: 'nylas',
      enoughLimits: false,
    },
    {
      email: 'email@lwolf.com',
      type: 'account-system',
      enoughLimits: true,
    },
    {
      email: 'email2@lwolf.com',
      type: 'account-system',
      enoughLimits: false,
    },
    {
      email: 'user@mymail.mydomain.com',
      type: 'auth-domain',
    },
    {
      email: 'user@ldmail.app',
      type: 'default-system',
    },
  ],
};

export const SENDGRID_LD_APP_SEND_SERVICE = 'sendgrid_ldapp';
export const SENDGRID_AUTH_SEND_SERVICE = 'sendgrid_auth';
export const NYLAS_SEND_SERVICE = 'nylas';
export const SENDGRID_NO_AUTH_SEND_SERVICE = 'sendgrid_no_auth';

export const NO_AUTH_DOMAIN_CHANNEL = 'no_auth_domain';
export const AUTH_DOMAIN_CHANNEL = 'auth_domain';

export const SEND_SERVICES_DESCRIPTIONS = {
  [SENDGRID_LD_APP_SEND_SERVICE]: 'Complimentary email',
  [SENDGRID_AUTH_SEND_SERVICE]: 'Authenticated domain',
  [NYLAS_SEND_SERVICE]: 'Connected email account',
  [SENDGRID_NO_AUTH_SEND_SERVICE]: 'Non-authenticated domain',
};

export const AUTHENTICATION_HELP_INFO_HASH = '#authenticate-help-info';
export const DEFAULT_SENDER_HELP_INFO_HASH = '#default-sender-help-info';

const IMPORTANCE_DOMAIN_AUTHENTICATION_LINK = 'https://lonewolf.my.site.com/s/article/COM-The-importance-of-email-domain-authentication-for-reliable-email-delivery';
const AUTH_DOMAIN_LINK = 'https://lonewolf.my.site.com/s/article/LD-Authenticate-a-personal-email-domain-LionDesk';

const BODY_HELP_INFO = `<a href="${IMPORTANCE_DOMAIN_AUTHENTICATION_LINK}" target="_blank">Read here</a> to see what is email authentication and why it is  important!<br><br>
<a href="${AUTH_DOMAIN_LINK}" target="_blank">Click here</a> to see how to authenticate your personal email domain.`;

export const HELP_INFO_CONTENT = {
  [AUTHENTICATION_HELP_INFO_HASH]: {
    title: 'Authenticate Your Email Domain',
    body: BODY_HELP_INFO,
    helpURLVideo: 'https://play.vidyard.com/PtDTzkUGbk7vHSWoQ4s8QZ.html',
    helpVideoTitle: 'Custom Domain Authentication',
  },
  [DEFAULT_SENDER_HELP_INFO_HASH]: {
    title: 'Default Sender For Campaigns',
    body: BODY_HELP_INFO,
  },
};

export const STORAGE_KEY_INCLUDE_DOMAIN = 'domain_auth_include_domain';